<template>
    <svg
        xmlns="http://www.w3.org/2000/svg" width="50" height="50" viewBox="0 0 50 50"
        fill="none"
    >
        <circle cx="25" cy="25" r="25" fill="#F6F8FA" />
        <g filter="url(#filter0_d_1347_7)">
            <circle cx="25.5" cy="25.5" r="17.5" fill="white" />
        </g>
        <path fill-rule="evenodd" clip-rule="evenodd" d="M19.375 23.3788V21.6667C19.375 18.5601 21.8934 16.0417 25 16.0417C28.1065 16.0417 30.625 18.5601 30.625 21.6667V23.3788C31.554 23.4482 32.1589 23.6233 32.601 24.0656C33.3333 24.7978 33.3333 25.9763 33.3333 28.3333C33.3333 30.6903 33.3333 31.8688 32.601 32.6011C31.8688 33.3333 30.6903 33.3333 28.3333 33.3333H21.6666C19.3096 33.3333 18.1311 33.3333 17.3989 32.6011C16.6666 31.8688 16.6666 30.6903 16.6666 28.3333C16.6666 25.9763 16.6666 24.7978 17.3989 24.0656C17.8411 23.6233 18.446 23.4482 19.375 23.3788ZM20.625 21.6667C20.625 19.2504 22.5837 17.2917 25 17.2917C27.4162 17.2917 29.375 19.2504 29.375 21.6667V23.3363C29.0558 23.3333 28.7095 23.3333 28.3333 23.3333H21.6666C21.2904 23.3333 20.9441 23.3333 20.625 23.3363V21.6667ZM26.6666 28.3333C26.6666 29.2538 25.9205 30 25 30C24.0795 30 23.3333 29.2538 23.3333 28.3333C23.3333 27.4128 24.0795 26.6667 25 26.6667C25.9205 26.6667 26.6666 27.4128 26.6666 28.3333Z" fill="#1C274C" />
        <defs>
            <filter
                id="filter0_d_1347_7" x="4" y="5" width="43"
                height="43" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB"
            >
                <feFlood flood-opacity="0" result="BackgroundImageFix" />
                <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                <feOffset dy="1" />
                <feGaussianBlur stdDeviation="2" />
                <feComposite in2="hardAlpha" operator="out" />
                <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0" />
                <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1347_7" />
                <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_1347_7" result="shape" />
            </filter>
        </defs>
    </svg>
</template>

<script>
export default {
    name: "AuthResetIcon",
};
</script>